import { fromPromise as FP, IPromiseBasedObservable as IPO } from "mobx-utils";

/** @deprecated use fetchModel instead */
export const fromPromise = FP;

/** @deprecated use fetchModel instead */
export type IPromiseBasedObservable<T> = IPO<T>;
